<div class="component-container meter-data-component">
  <app-review-section
    #meterDataSection
    [title]="'basic-profile.jurisdiction.meter-data.meter_data' | translate"
    [tooltip]="'tooltips.facilities-data.meter-data' | translate"
    [showTooltip]="infoBubblesData?.showMeterDataHeaderInfo"
    [sectionId]="technicalDataMeterDataSectionIdentifier"
    [applicationId]="applicationId"
    [isDetailsView]="isDetailsView"
    [showButtonsPredicate]="hideButtonsForEmployeeWhenHasChimneySweeper"></app-review-section>
  <form *ngIf="meterDataFG" [formGroup]="meterDataFG" autocomplete="off">
    <div *ngFor="let meter of metersObj.controls; let i = index" formArrayName="meters">
      <div [formGroupName]="i" class="ui-g meter-section form-font-size">
        <div class="ui-g-12">
          <div class="ui-g form-rows relative-position">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('meterType')">
              <label class="ui-g-5 field-label text-right-align required">
                {{
                  (showTypeOfUseAsMeterType
                    ? 'basic-profile.jurisdiction.meter-data.type-of-use'
                    : 'basic-profile.jurisdiction.meter-data.meter_type'
                  ) | translate
                }}
              </label>
              <p-dropdown
                (onChange)="selectMeterType($event, i)"
                [options]="typeOfMeters"
                formControlName="meterType"
                id="meter-type-{{ i }}"
                placeholder="-Select-"
                [readonly]="!meterDataSection.isDataEditable || !showMeterTypeAsDropdown">
                <ng-template let-item pTemplate="selectedItem">
                  <span class="drop-item-label">{{ 'lookup.' + meterTypeKey + '.options.' + item['value'] + '.name' | translate }}</span>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <div class="drop-item">
                    <span class="drop-item-label">
                      {{ 'lookup.' + meterTypeKey + '.options.' + option['value'] + '.name' | translate }}
                    </span>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
            <div
              class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 field-rows"
              *ngIf="formType.key === 'water' && meter.get('alignment')">
              <p-radioButton
                class="alignment-radio-buttons"
                formControlName="alignment"
                label="{{ 'lookup.sk_mounting_alignment.options.horizontal.name' | translate }}"
                name="mounting_alignment-{{ i }}"
                value="horizontal"></p-radioButton>
              <p-radioButton
                class="alignment-radio-buttons"
                formControlName="alignment"
                label="{{ 'lookup.sk_mounting_alignment.options.vertical.name' | translate }}"
                name="mounting_alignment-{{ i }}"
                value="vertical"></p-radioButton>
            </div>
            <div class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="formType.key === 'gas'">
              <p-checkbox
                binary="true"
                [readonly]="!meterDataSection.isDataEditable"
                formControlName="remoteReadoutCheckbox"
                id="remote-readout-check"
                label="{{ 'basic-profile.jurisdiction.meter-data.remote-readout' | translate }}"></p-checkbox>
            </div>
            <div class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('swknRemoteReadoutCheckbox')">
              <p-checkbox
                binary="true"
                [readonly]="!meterDataSection.isDataEditable"
                formControlName="swknRemoteReadoutCheckbox"
                id="swkn-remote-readout-check"
                label="{{ 'basic-profile.jurisdiction.meter-data.swkn-remote-readout' | translate }}"></p-checkbox>
            </div>
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="showControlUnitAvailableCheckbox(i)">
              <label class="ui-g-3"></label>
              <p-checkbox
                binary="true"
                [readonly]="!meterDataSection.isDataEditable"
                formControlName="controlUnitAvailableCheckbox"
                id="control-unit-check"
                label="{{ 'basic-profile.jurisdiction.meter-data.control-unit-available' | translate }}"></p-checkbox>
            </div>
            <div *ngIf="meterDataSection.isDataEditable && metersObj.controls.length > 1" class="top-right-position">
              <div (click)="removeMeter(i)" class="pi pi-trash pointer-cursor"></div>
            </div>
          </div>
        </div>

        <ng-container
          *ngIf="
            meterType[i] === 'modern' ||
            meterType[i] === 'modern_ac' ||
            meterType[i] === 'modern_3phase' ||
            (meterType[i] === 'control_unit' && meterTypeControlUnit)
          ">
          <div class="ui-g-12">
            <div class="ui-g form-rows">
              <div
                *ngIf="formType.key === 'power' && meter.get('modernMeterSubtype')"
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align" [class.required]="isFieldRequired(meter.get('modernMeterSubtype'))">
                  {{ 'basic-profile.jurisdiction.meter-data.type' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable || !showModernMeterSubtypeAsDropdown"
                  [options]="modernMeterSubtypeList && meterType[i] === 'modern' ? doublerateMeterOptions : modernMeterType"
                  formControlName="modernMeterSubtype"
                  id="meter-subtype-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{
                        'lookup.' +
                          (modernMeterSubtypeList && meterType[i] === 'modern' ? doublerateMeterKey : modernMeterKey) +
                          '.options.' +
                          item['value'] +
                          '.name' | translate
                      }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{
                          'lookup.' +
                            (modernMeterSubtypeList && meterType[i] === 'modern' ? doublerateMeterKey : modernMeterKey) +
                            '.options.' +
                            option['value'] +
                            '.name' | translate
                        }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"
                *ngIf="!showFloor && meter.get('amount') && !environmentService.copyExistingTechnicalDataConfiguration">
                <label
                  class="ui-g-5 field-label text-right-align"
                  [class.required]="meterTypeControlUnit || meterType[i] !== 'control_unit'"
                  for="meter-amount-{{ i }}">
                  {{ 'basic-profile.jurisdiction.meter-data.amount' | translate }}
                </label>
                <input
                  [appNumber]="true"
                  class="small-width"
                  id="meter-amount-{{ i }}"
                  formControlName="amount"
                  pInputText
                  [readonly]="!meterDataSection.isDataEditable" />
              </div>
              <div
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"
                *ngIf="environmentService.copyExistingTechnicalDataConfiguration && !environmentService.hideLocationField"
                [class.disabled]="true">
                <label class="ui-g-3 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.location' | translate }}
                </label>
                <input
                  [appNumber]="true"
                  class="small-width"
                  [class.disabled]="true"
                  pInputText
                  [readonly]="!meterDataSection.isDataEditable" />
              </div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="showFloor && meter.get('swknFloor')">
                <label
                  class="ui-g-5 field-label text-right-align"
                  [class.required]="meterTypeControlUnit || meterType[i] !== 'control_unit'"
                  for="meter-swkn-floor-{{ i }}">
                  {{ 'basic-profile.jurisdiction.meter-data.floor_no' | translate }}
                </label>
                <input
                  [appNumber]="environmentService.numberOfApartmentRegex"
                  class="small-width"
                  id="meter-swkn-floor-{{ i }}"
                  formControlName="swknFloor"
                  pInputText
                  [readonly]="!meterDataSection.isDataEditable" />
              </div>
            </div>

            <div class="ui-g form-rows" *ngIf="meter.get('selectMount')">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label [class.required]="formType && formType.index === 0" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.mount' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable || !enableSelectMountDropdown"
                  [(ngModel)]="selectMount[i]"
                  [options]="meterMount"
                  formControlName="selectMount"
                  id="modern-mount-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">{{ 'lookup.' + meterMountKey + '.options.' + item['value'] + '.name' | translate }}</span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + meterMountKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('concept')">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'technical-data.select-concept' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  [options]="measuringConceptsOptions"
                  formControlName="concept"
                  id="concept-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{ 'lookup.' + measuringConceptKey + '.options.' + item['value'] + '.name' | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + measuringConceptKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
            <div *ngIf="selectMount[i] === 'plugin_mounting'" class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <div class="ui-g-offset-5" *ngIf="showPluginMountingWarning">
                  {{ 'basic-profile.jurisdiction.meter-data.plugin_mounting_warning' | translate }}
                </div>
              </div>
            </div>
            <div class="ui-g form-rows" *ngIf="meter.get('annualConsumption')">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label [class.required]="isFieldRequired(meter.get('annualConsumption'))" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.annual_consumption' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  [options]="annualConsumptionOptions"
                  formControlName="annualConsumption"
                  id="annual-consumption1-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{ 'lookup.' + annualConsumptionKey + '.options.' + item['value'] + '.name' | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + annualConsumptionKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
                <span class="unit-margin">{{ annualConsumptionUnit }}</span>
              </div>
            </div>
            <div class="ui-g form-rows" *ngIf="meter.get('rlmMeasurement')">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label [class.required]="isFieldRequired(meter.get('rlmMeasurement'))" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.rlm-measurement' | translate }}
                </label>
                <div class="p-field-checkbox flex">
                  <p-checkbox binary="true" [readonly]="!meterDataSection.isDataEditable" formControlName="rlmMeasurement"></p-checkbox>
                  <label>{{ 'basic-profile.jurisdiction.meter-data.rlm-measurement-info' | translate }}</label>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="ui-g-12" *ngIf="meter.get('oldMeterNumber')">
          <div class="ui-g form-rows">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
              <label class="ui-g-5 field-label text-right-align" [class.required]="isFieldRequired(meter.get('oldMeterNumber'))">
                {{ 'basic-profile.jurisdiction.meter-data.old_meter_number' | translate }}
              </label>
              <input
                [appNumber]="environmentService.oldMeterNumberRegex"
                formControlName="oldMeterNumber"
                pInputText
                [readonly]="!meterDataSection.isDataEditable" />
            </div>
          </div>
        </div>

        <ng-container *ngIf="meterType[i] === 'intelligent'">
          <div class="ui-g-12">
            <div class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <ng-container *ngIf="showCommunicationAndMountType">
                  <label class="ui-g-5 field-label text-right-align" [class.required]="formType.index === 0">
                    {{ 'basic-profile.jurisdiction.meter-data.communication' | translate }}
                  </label>
                  <p-dropdown
                    [readonly]="!meterDataSection.isDataEditable"
                    [options]="meterCommunication"
                    formControlName="selectComm"
                    id="intelligent-comm-{{ i }}"
                    placeholder="-Select-">
                    <ng-template let-item pTemplate="selectedItem">
                      <span class="drop-item-label">
                        {{ 'lookup.' + meterCommunicationKey + '.options.' + item['value'] + '.name' | translate }}
                      </span>
                    </ng-template>
                    <ng-template let-option pTemplate="item">
                      <div class="drop-item">
                        <span class="drop-item-label">
                          {{ 'lookup.' + meterCommunicationKey + '.options.' + option['value'] + '.name' | translate }}
                        </span>
                      </div>
                    </ng-template>
                  </p-dropdown>
                </ng-container>
              </div>
              <div
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"
                *ngIf="!showFloor && !environmentService.copyExistingTechnicalDataConfiguration">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'basic-profile.jurisdiction.meter-data.amount' | translate }}
                </label>
                <input
                  [appNumber]="true"
                  class="small-width"
                  formControlName="amount"
                  pInputText
                  [readonly]="!meterDataSection.isDataEditable" />
              </div>

              <div
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"
                *ngIf="environmentService.copyExistingTechnicalDataConfiguration && !environmentService.hideLocationField"
                [class.disabled]="true">
                <label class="ui-g-3 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.location' | translate }}
                </label>
                <input
                  [appNumber]="true"
                  class="small-width"
                  [class.disabled]="true"
                  pInputText
                  [readonly]="!meterDataSection.isDataEditable" />
              </div>

              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows count" *ngIf="showFloor">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'basic-profile.jurisdiction.meter-data.floor_no' | translate }}
                </label>
                <input
                  [appNumber]="true"
                  class="small-width"
                  formControlName="swknFloor"
                  pInputText
                  [readonly]="!meterDataSection.isDataEditable" />
              </div>
            </div>
            <div class="ui-g form-rows" *ngIf="showCommunicationAndMountType">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('selectMount')">
                <label [class.required]="formType && formType.index === 0" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.mount' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable || !enableSelectMountDropdown"
                  [(ngModel)]="selectMount[i]"
                  [options]="meterMount"
                  formControlName="selectMount"
                  id="intelligent-mount-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">{{ 'lookup.' + meterMountKey + '.options.' + item['value'] + '.name' | translate }}</span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + meterMountKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('concept')">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'technical-data.select-concept' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  [options]="measuringConceptsOptions"
                  formControlName="concept"
                  id="concept-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{ 'lookup.' + measuringConceptKey + '.options.' + item['value'] + '.name' | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + measuringConceptKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
            <div *ngIf="selectMount[i] === 'plugin_mounting'" class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <div class="ui-g-offset-5">
                  {{ 'basic-profile.jurisdiction.meter-data.plugin_mounting_warning' | translate }}
                </div>
              </div>
            </div>
            <div class="ui-g form-rows" *ngIf="meter.get('annualConsumption')">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label [class.required]="isFieldRequired(meter.get('annualConsumption'))" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.annual_consumption' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  [options]="annualConsumptionOptions"
                  formControlName="annualConsumption"
                  id="annual-consumption2-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{ 'lookup.' + annualConsumptionKey + '.options.' + item['value'] + '.name' | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + annualConsumptionKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
                <span class="unit-margin">{{ annualConsumptionUnit }}</span>
              </div>
            </div>
            <div class="ui-g form-rows" *ngIf="meter.get('rlmMeasurement')">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label [class.required]="isFieldRequired(meter.get('rlmMeasurement'))" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.rlm-measurement' | translate }}
                </label>
                <div class="p-field-checkbox flex">
                  <p-checkbox binary="true" [readonly]="!meterDataSection.isDataEditable" formControlName="rlmMeasurement"></p-checkbox>
                  <label>{{ 'basic-profile.jurisdiction.meter-data.rlm-measurement-info' | translate }}</label>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container
          *ngIf="
            formType.key === 'power' &&
            (meterType[i] === 'transducer' || (currentFlowType === installationFlowType.SiteElectricityMeterdata && !meterType[i]))
          "
          class="ui-g-12">
          <div class="ui-g-12">
            <div class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('transducerSize')">
                <label [class.required]="formType && formType.index === 0" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.transducer_size' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  [options]="transducerSizeOptions"
                  formControlName="transducerSize"
                  id="transducer-size-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{ 'lookup.' + transducerSizeKey + '.options.' + item['value'] + '.name' | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + transducerSizeKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>

              <div
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"
                *ngIf="environmentService.copyExistingTechnicalDataConfiguration && !environmentService.hideLocationField"
                [class.disabled]="true">
                <label class="ui-g-3 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.location' | translate }}
                </label>
                <input
                  [appNumber]="true"
                  class="small-width"
                  [class.disabled]="true"
                  pInputText
                  [readonly]="!meterDataSection.isDataEditable" />
              </div>

              <ng-container *ngIf="environmentService.isMeterDataDependentOnOperator && selectedMeasuringPointOperator === 'other'">
                <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-6 ui-sm-6 ui-xs-12 field-rows" *ngIf="meter.get('providedByMsbCheckbox')">
                  <div class="p-field-checkbox">
                    <p-checkbox
                      (onChange)="msbCheckbox($event, i)"
                      binary="true"
                      formControlName="providedByMsbCheckbox"
                      [readonly]="!meterDataSection.isDataEditable"></p-checkbox>
                    <label>{{ 'basic-profile.jurisdiction.meter-data.transformer_prov_by_msb' | translate }}</label>
                  </div>
                </div>
                <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-6 ui-sm-6 ui-xs-12 field-rows" *ngIf="meter.get('msbName')">
                  <label class="ui-g-5 field-label text-right-align" [class.required]="isFieldRequired(meter.get('msbName'))">
                    {{ 'basic-profile.jurisdiction.meter-data.name_msb' | translate }}
                  </label>
                  <input formControlName="msbName" pInputText type="text" [readonly]="!meterDataSection.isDataEditable" />
                </div>
              </ng-container>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('transformerFactor')">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'basic-profile.jurisdiction.meter-data.transformer_factor' | translate }}
                </label>
                <input formControlName="transformerFactor" pInputText [appNumber]="true" [readonly]="!meterDataSection.isDataEditable" />
                <span class="add-label" *ngIf="showLabelForTransformerSize">A</span>
              </div>
              <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-6 ui-sm-6 ui-xs-12 field-rows" *ngIf="meter.get('providedByCustomerCheckbox')">
                <div class="p-field-checkbox">
                  <p-checkbox
                    (onChange)="customerCheckbox($event, i)"
                    binary="true"
                    formControlName="providedByCustomerCheckbox"
                    [readonly]="!meterDataSection.isDataEditable"></p-checkbox>
                  <label>{{ 'basic-profile.jurisdiction.meter-data.transformer_prov_by_cust' | translate }}</label>
                </div>
              </div>
              <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-6 ui-sm-6 ui-xs-12 field-rows" *ngIf="meter.get('customerName')">
                <label class="ui-g-5 field-label text-right-align" [class.required]="isFieldRequired(meter.get('customerName'))">
                  {{ 'basic-profile.jurisdiction.meter-data.name_cust' | translate }}
                </label>
                <input formControlName="customerName" pInputText type="text" [readonly]="!meterDataSection.isDataEditable" />
              </div>
            </div>
            <div class="ui-g form-rows" *ngIf="!environmentService.isMeterDataDependentOnOperator || meter.get('selectMount')">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('selectMount')">
                <label [class.required]="formType && formType.index === 0" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.mount' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable || !enableSelectMountDropdown"
                  [(ngModel)]="selectMount[i]"
                  [options]="meterMount"
                  formControlName="selectMount"
                  id="transducer-mount-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">{{ 'lookup.' + meterMountKey + '.options.' + item['value'] + '.name' | translate }}</span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + meterMountKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"
                *ngIf="meter.get('providedByCustomerCheckbox')?.value && environmentService.showTransformerCustomerLabel">
                <label class="ui-g-12 field-label">
                  {{ 'basic-profile.jurisdiction.meter-data.transformer_prov_by_cust_label' | translate }}
                </label>
              </div>
              <ng-container *ngIf="!environmentService.isMeterDataDependentOnOperator">
                <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-6 ui-sm-6 ui-xs-12 field-rows" *ngIf="meter.get('providedByMsbCheckbox')">
                  <div class="p-field-checkbox">
                    <p-checkbox
                      (onChange)="msbCheckbox($event, i)"
                      binary="true"
                      formControlName="providedByMsbCheckbox"
                      [readonly]="!meterDataSection.isDataEditable"></p-checkbox>
                    <label>{{ 'basic-profile.jurisdiction.meter-data.transformer_prov_by_msb' | translate }}</label>
                  </div>
                </div>
                <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-6 ui-sm-6 ui-xs-12 field-rows" *ngIf="meter.get('msbName')">
                  <label class="ui-g-5 field-label text-right-align" [class.required]="isFieldRequired(meter.get('msbName'))">
                    {{ 'basic-profile.jurisdiction.meter-data.name_msb' | translate }}
                  </label>
                  <input formControlName="msbName" pInputText type="text" [readonly]="!meterDataSection.isDataEditable" />
                </div>
              </ng-container>
            </div>
            <div *ngIf="selectMount[i] === 'plugin_mounting'" class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <div class="ui-g-offset-5">
                  {{ 'basic-profile.jurisdiction.meter-data.plugin_mounting_warning' | translate }}
                </div>
              </div>
            </div>
            <div class="ui-g form-rows" *ngIf="meterType[i] && meter.get('annualConsumption')">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label [class.required]="isFieldRequired(meter.get('annualConsumption'))" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.annual_consumption' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  [options]="annualConsumptionOptions"
                  formControlName="annualConsumption"
                  id="annual-consumption3-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{ 'lookup.' + annualConsumptionKey + '.options.' + item['value'] + '.name' | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + annualConsumptionKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
                <span class="unit-margin">{{ annualConsumptionUnit }}</span>
              </div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('concept')">
                <label class="ui-g-5 margin-left required">
                  {{ 'technical-data.select-concept' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  [options]="measuringConceptsOptions"
                  formControlName="concept"
                  id="concept-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{ 'lookup.' + measuringConceptKey + '.options.' + item['value'] + '.name' | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + measuringConceptKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
            <div class="ui-g form-rows" *ngIf="meter.get('rlmMeasurement')">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label [class.required]="isFieldRequired(meter.get('rlmMeasurement'))" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.rlm-measurement' | translate }}
                </label>
                <div class="p-field-checkbox flex">
                  <p-checkbox binary="true" [readonly]="!meterDataSection.isDataEditable" formControlName="rlmMeasurement"></p-checkbox>
                  <label>{{ 'basic-profile.jurisdiction.meter-data.rlm-measurement-info' | translate }}</label>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="meterType[i] === 'remote' && formType.key === 'power'">
          <div class="ui-g-12">
            <div class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="showCommunicationAndMountType">
                <label class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.communication' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  [options]="meterCommunication"
                  formControlName="selectComm"
                  id="remote-comm-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{ 'lookup.' + meterCommunicationKey + '.options.' + item['value'] + '.name' | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + meterCommunicationKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('amount')">
                <label class="ui-g-3 field-label text-right-align required">
                  {{ 'basic-profile.jurisdiction.meter-data.amount' | translate }}
                </label>
                <input
                  [appNumber]="true"
                  class="small-width"
                  formControlName="amount"
                  pInputText
                  [readonly]="!meterDataSection.isDataEditable" />
              </div>
            </div>
            <div class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('selectMount')">
                <label [class.required]="formType && formType.index === 0" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.mount' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable || !enableSelectMountDropdown"
                  [(ngModel)]="selectMount[i]"
                  [options]="meterMount"
                  formControlName="selectMount"
                  id="remote-mount-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">{{ 'lookup.' + meterMountKey + '.options.' + item['value'] + '.name' | translate }}</span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + meterMountKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
            <div *ngIf="selectMount[i] === 'plugin_mounting'" class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <div class="ui-g-offset-5">
                  {{ 'basic-profile.jurisdiction.meter-data.plugin_mounting_warning' | translate }}
                </div>
              </div>
            </div>
            <div class="ui-g form-rows" *ngIf="meter.get('annualConsumption')">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label [class.required]="isFieldRequired(meter.get('annualConsumption'))" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.annual_consumption' | translate }}4
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  [options]="annualConsumptionOptions"
                  formControlName="annualConsumption"
                  id="annual-consumption4-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{ 'lookup.' + annualConsumptionKey + '.options.' + item['value'] + '.name' | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + annualConsumptionKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
                <span class="unit-margin">{{ annualConsumptionUnit }}</span>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="meterType[i] === 'profile' && formType.key === 'power'">
          <div class="ui-g-12">
            <div class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('selectMount')">
                <label [class.required]="formType && formType.index === 0" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.mount' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable || !enableSelectMountDropdown"
                  [(ngModel)]="selectMount[i]"
                  [options]="meterMount"
                  formControlName="selectMount"
                  id="profile-mount-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">{{ 'lookup.' + meterMountKey + '.options.' + item['value'] + '.name' | translate }}</span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + meterMountKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="!showFloor">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'basic-profile.jurisdiction.meter-data.amount' | translate }}
                </label>
                <input
                  [appNumber]="true"
                  formControlName="amount"
                  pInputText
                  [readonly]="!meterDataSection.isDataEditable"
                  [class.small-width]="!!meter.get('selectMount')" />
              </div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="showFloor">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'basic-profile.jurisdiction.meter-data.floor_no' | translate }}
                </label>
                <input
                  [appNumber]="environmentService.numberOfApartmentRegex"
                  class="small-width"
                  formControlName="swknFloor"
                  pInputText
                  [readonly]="!meterDataSection.isDataEditable" />
              </div>
            </div>
            <div *ngIf="selectMount[i] === 'plugin_mounting'" class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <div class="ui-g-offset-5">
                  {{ 'basic-profile.jurisdiction.meter-data.plugin_mounting_warning' | translate }}
                </div>
              </div>
            </div>
            <div class="ui-g form-rows" *ngIf="meter.get('annualConsumption')">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label [class.required]="isFieldRequired(meter.get('annualConsumption'))" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.annual_consumption' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  [options]="annualConsumptionOptions"
                  formControlName="annualConsumption"
                  id="annual-consumption-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{ 'lookup.' + annualConsumptionKey + '.options.' + item['value'] + '.name' | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + annualConsumptionKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
                <span class="unit-margin">{{ annualConsumptionUnit }}</span>
              </div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('concept')">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'technical-data.select-concept' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  [options]="measuringConceptsOptions"
                  formControlName="concept"
                  id="concept-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{ 'lookup.' + measuringConceptKey + '.options.' + item['value'] + '.name' | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + measuringConceptKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
            <div class="ui-g form-rows" *ngIf="meter.get('rlmMeasurement')">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label [class.required]="isFieldRequired(meter.get('rlmMeasurement'))" class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.rlm-measurement' | translate }}
                </label>
                <div class="p-field-checkbox flex">
                  <p-checkbox binary="true" [readonly]="!meterDataSection.isDataEditable" formControlName="rlmMeasurement"></p-checkbox>
                  <label>{{ 'basic-profile.jurisdiction.meter-data.rlm-measurement-info' | translate }}</label>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="meterType[i] === 'transducer' && formType.key !== 'power'">
          <div class="ui-g-12">
            <div class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'basic-profile.jurisdiction.meter-data.counter_size' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  (onChange)="prepareMeterCharacteristicData($event.value, i)"
                  [options]="counterSizeList && meterType[i] === 'transducer' ? swknHeatMeterSizeOptions : meterSizeOptions"
                  formControlName="counterSize"
                  id="meter-size1-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{
                        'lookup.' +
                          (counterSizeList && meterType[i] === 'transducer' ? swknHeatMeterSizeKey : meterSizeKey) +
                          '.options.' +
                          item['value'] +
                          '.name' | translate
                      }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{
                          'lookup.' +
                            (counterSizeList && meterType[i] === 'transducer' ? swknHeatMeterSizeKey : meterSizeKey) +
                            '.options.' +
                            option['value'] +
                            '.name' | translate
                        }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>

              <div
                class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 field-rows"
                *ngIf="formType.key === 'water' && !hideMeterCompliance">
                <p-radioButton
                  class="alignment-radio-buttons"
                  formControlName="meterCompliance"
                  label="{{ 'lookup.sk_standard_compliance.options.din1988.name' | translate }}"
                  name="meter-compliance-{{ i }}"
                  value="din1988"></p-radioButton>
                <p-radioButton
                  class="alignment-radio-buttons"
                  formControlName="meterCompliance"
                  label="{{ 'lookup.sk_standard_compliance.options.dvgww406.name' | translate }}"
                  name="meter-compliance-{{ i }}"
                  value="dvgww406"></p-radioButton>
              </div>
              <div
                *ngIf="formType.key === 'water' && meter.get('amount')"
                class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding print-top-padding">
                <label class="ui-g-5 field-label text-right-align required">
                  {{ 'basic-profile.jurisdiction.meter-data.amount' | translate }}
                </label>
                <input
                  [appNumber]="true"
                  class="small-width"
                  formControlName="amount"
                  pInputText
                  [readonly]="!meterDataSection.isDataEditable" />
              </div>
              <div
                *ngIf="formType.key !== 'water' && meter.get('amount') && showAmount()"
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding print-top-padding">
                <div *ngIf="!environmentService.copyExistingTechnicalDataConfiguration">
                  <label class="ui-g-5 field-label text-right-align required">
                    {{ 'basic-profile.jurisdiction.meter-data.amount' | translate }}
                  </label>
                  <input
                    [appNumber]="true"
                    class="small-width"
                    formControlName="amount"
                    pInputText
                    [readonly]="!meterDataSection.isDataEditable" />
                </div>
                <div
                  *ngIf="environmentService.copyExistingTechnicalDataConfiguration && !environmentService.hideLocationField"
                  [class.disabled]="true">
                  <label class="ui-g-3 field-label text-right-align">
                    {{ 'basic-profile.jurisdiction.meter-data.location' | translate }}
                  </label>
                  <input
                    [appNumber]="true"
                    class="small-width"
                    [class.disabled]="true"
                    pInputText
                    [readonly]="!meterDataSection.isDataEditable" />
                </div>
              </div>
            </div>
            <ng-container *ngIf="meter.get('meterThread')">
              <div class="ui-g form-rows">
                <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                  <label class="ui-g-5 field-label text-right-align">
                    {{ 'basic-profile.jurisdiction.meter-data.meter_thread' | translate }}
                  </label>
                  <input class="meter-characteristic" formControlName="meterThread" pInputText [readonly]="true" />
                </div>
                <div class="ui-g-6 field-rows">
                  <label class="ui-g-5 field-label text-right-align">
                    {{ 'basic-profile.jurisdiction.meter-data.meter_flange' | translate }}
                  </label>
                  <input class="meter-characteristic" formControlName="meterFlange" pInputText [readonly]="true" />
                </div>
              </div>

              <div class="ui-g form-rows">
                <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                  <label class="ui-g-5 field-label text-right-align">
                    {{ 'basic-profile.jurisdiction.meter-data.overall_length' | translate }}
                  </label>
                  <input class="meter-characteristic" formControlName="overAllLength" pInputText [readonly]="true" />
                  <span class="unit-margin">{{ allUnits.millimeter }}</span>
                </div>
                <div class="ui-g-6 field-rows">
                  <label class="ui-g-5 field-label text-right-align">
                    {{ 'basic-profile.jurisdiction.meter-data.sensor_length' | translate }}
                  </label>
                  <input class="meter-characteristic" formControlName="sensorLength" pInputText [readonly]="true" />
                  <span class="unit-margin">{{ allUnits.millimeter }}</span>
                </div>
              </div>

              <div class="ui-g form-rows">
                <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                  <label class="ui-g-5 field-label text-right-align">
                    {{ 'basic-profile.jurisdiction.meter-data.sensor_thread' | translate }}
                  </label>
                  <input class="meter-characteristic" formControlName="sensorThread" pInputText [readonly]="true" />
                </div>
              </div>
            </ng-container>
            <div *ngIf="checkSelectedMeterSize(i)" class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align" for="other-meter-type-{{ i }}"></label>
                <input
                  class="ui-input pInputText"
                  formControlName="otherType"
                  id="other-meter-type1-{{ i }}"
                  pInputText
                  type="text"
                  [readonly]="!meterDataSection.isDataEditable" />
              </div>
            </div>

            <div class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('annualConsumptionForecast')">
                <label class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.annual_consumption_forecast' | translate }}
                </label>
                <input
                  [appNumber]="true"
                  formControlName="annualConsumptionForecast"
                  pInputText
                  [readonly]="!meterDataSection.isDataEditable" />
                <span class="unit-margin">{{ annualConsumptionUnit }}</span>
              </div>
            </div>
            <div class="ui-g form-rows">
              <div *ngIf="formType.key === 'heating' && meter.get('requestedTotalPower')" class="ui-g-6 field-rows">
                <label class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.requested_total_power' | translate }}
                </label>
                <input [appNumber]="true" formControlName="requestedTotalPower" pInputText [readonly]="!meterDataSection.isDataEditable" />
                <span class="unit-margin">{{ allUnits.power }}</span>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container
          *ngIf="
            ((meterType[i] === 'remote' || meterType[i] === 'simple' || meterType[i] === 'own_water') && formType.key !== 'power') ||
            (formType.key === 'gas' && meterType[i] === 'bellows_meter')
          ">
          <div class="ui-g-12">
            <div class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align" [class.required]="isFieldRequired(meter.get('counterSize'))">
                  {{ 'basic-profile.jurisdiction.meter-data.counter_size' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  [options]="meterSizeOptions"
                  formControlName="counterSize"
                  id="meter-size-{{ i }}"
                  placeholder="-Select-"
                  (onChange)="prepareMeterCharacteristicData($event.value, i)">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">{{ 'lookup.' + meterSizeKey + '.options.' + item['value'] + '.name' | translate }}</span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + meterSizeKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>

              <div
                class="ui-g-3 ui-xl-4 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 field-rows"
                *ngIf="formType.key === 'water' && !hideMeterCompliance">
                <p-radioButton
                  class="alignment-radio-buttons"
                  formControlName="meterCompliance"
                  label="{{ 'lookup.sk_standard_compliance.options.din1988.name' | translate }}"
                  name="meter-compliance-{{ i }}"
                  value="din1988"></p-radioButton>
                <p-radioButton
                  class="alignment-radio-buttons"
                  formControlName="meterCompliance"
                  label="{{ 'lookup.sk_standard_compliance.options.dvgww406.name' | translate }}"
                  name="meter-compliance-{{ i }}"
                  value="dvgww406"></p-radioButton>
              </div>
              <div
                *ngIf="formType.key === 'water' && meter.get('amount')"
                class="ui-g-3 ui-xl-2 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding print-top-padding">
                <div
                  *ngIf="
                    meterType[i] !== 'simple' && meterType[i] !== 'own_water' && !environmentService.copyExistingTechnicalDataConfiguration
                  ">
                  <label class="ui-g-5 field-label text-right-align" [class.required]="isFieldRequired(meter.get('amount'))">
                    {{ 'basic-profile.jurisdiction.meter-data.amount' | translate }}
                  </label>
                  <input
                    [appNumber]="true"
                    class="small-width"
                    formControlName="amount"
                    pInputText
                    [readonly]="!meterDataSection.isDataEditable" />
                </div>
              </div>
              <div
                *ngIf="formType.key !== 'water' && formType.key !== 'gas' && meter.get('amount') && showAmount()"
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding print-top-padding">
                <div *ngIf="!environmentService.copyExistingTechnicalDataConfiguration">
                  <label class="ui-g-5 field-label text-right-align required">
                    {{ 'basic-profile.jurisdiction.meter-data.amount' | translate }}
                  </label>
                  <input
                    [appNumber]="true"
                    class="small-width"
                    formControlName="amount"
                    pInputText
                    [readonly]="!meterDataSection.isDataEditable" />
                </div>
                <div
                  *ngIf="environmentService.copyExistingTechnicalDataConfiguration && !environmentService.hideLocationField"
                  [class.disabled]="true">
                  <label class="ui-g-3 field-label text-right-align">
                    {{ 'basic-profile.jurisdiction.meter-data.location' | translate }}
                  </label>
                  <input
                    [appNumber]="true"
                    class="small-width"
                    [class.disabled]="true"
                    pInputText
                    [readonly]="!meterDataSection.isDataEditable" />
                </div>
              </div>
            </div>
            <ng-container *ngIf="formType.key === 'heating' && meterType[i] === 'remote' && meter.get('meterThread')">
              <div class="ui-g form-rows">
                <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                  <label class="ui-g-5 field-label text-right-align">
                    {{ 'basic-profile.jurisdiction.meter-data.meter_thread' | translate }}
                  </label>
                  <input class="meter-characteristic" formControlName="meterThread" pInputText [readonly]="true" />
                </div>
                <div class="ui-g-6 field-rows">
                  <label class="ui-g-5 field-label text-right-align">
                    {{ 'basic-profile.jurisdiction.meter-data.meter_flange' | translate }}
                  </label>
                  <input class="meter-characteristic" formControlName="meterFlange" pInputText [readonly]="true" />
                </div>
              </div>

              <div class="ui-g form-rows">
                <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                  <label class="ui-g-5 field-label text-right-align">
                    {{ 'basic-profile.jurisdiction.meter-data.overall_length' | translate }}
                  </label>
                  <input class="meter-characteristic" formControlName="overAllLength" pInputText [readonly]="true" />
                  <span class="unit-margin">{{ allUnits.millimeter }}</span>
                </div>
                <div class="ui-g-6 field-rows">
                  <label class="ui-g-5 field-label text-right-align">
                    {{ 'basic-profile.jurisdiction.meter-data.sensor_length' | translate }}
                  </label>
                  <input class="meter-characteristic" formControlName="sensorLength" pInputText [readonly]="true" />
                  <span class="unit-margin">{{ allUnits.millimeter }}</span>
                </div>
              </div>

              <div class="ui-g form-rows">
                <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                  <label class="ui-g-5 field-label text-right-align">
                    {{ 'basic-profile.jurisdiction.meter-data.sensor_thread' | translate }}
                  </label>
                  <input class="meter-characteristic" formControlName="sensorThread" pInputText [readonly]="true" />
                </div>
              </div>
            </ng-container>
            <div *ngIf="checkSelectedMeterSize(i)" class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align required" for="other-meter-type-{{ i }}">
                  {{ 'basic-profile.jurisdiction.meter-data.info_on_other_meter_size' | translate }}
                </label>
                <input
                  class="ui-input pInputText"
                  formControlName="otherType"
                  id="other-meter-type-{{ i }}"
                  pInputText
                  type="text"
                  [readonly]="!meterDataSection.isDataEditable" />
              </div>
            </div>

            <div class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="meter.get('annualConsumptionForecast')">
                <label class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.annual_consumption_forecast' | translate }}
                </label>
                <input
                  [appNumber]="true"
                  formControlName="annualConsumptionForecast"
                  pInputText
                  [readonly]="!meterDataSection.isDataEditable" />
                <span class="unit-margin">{{ annualConsumptionUnit }}</span>
              </div>

              <div *ngIf="formType.key === 'heating' && meter.get('requestedTotalPower')" class="ui-g-6 field-rows">
                <label class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.requested_total_power' | translate }}
                </label>
                <input [appNumber]="true" formControlName="requestedTotalPower" pInputText [readonly]="!meterDataSection.isDataEditable" />
                <span class="unit-margin">{{ allUnits.power }}</span>
              </div>
            </div>

            <div class="ui-g form-rows" *ngIf="meterType[i] === 'remote'">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="showCommunicationAndMountType">
                <label class="ui-g-5 field-label text-right-align">
                  {{ 'basic-profile.jurisdiction.meter-data.communication' | translate }}
                </label>
                <p-dropdown
                  [readonly]="!meterDataSection.isDataEditable"
                  [options]="meterCommunication"
                  formControlName="selectComm"
                  id="meter-comm-{{ i }}"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{ 'lookup.' + meterCommunicationKey + '.options.' + item['value'] + '.name' | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + meterCommunicationKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="ui-g-12">
          <div clas="ui-g form-rows" *ngIf="meter.get('location') && environmentService.copyExistingTechnicalDataConfiguration">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
              <label class="ui-g-5 field-label text-right-align required">
                {{ 'basic-profile.jurisdiction.meter-data.location' | translate }}
              </label>
              <input type="text" formControlName="location" pInputText [readonly]="!meterDataSection.isDataEditable" />
              <i
                class="pi pi-info-circle hint-icon"
                *ngIf="environmentService.showMeterLocationInfoPopup"
                tooltipStyleClass="netz-info-tooltip"
                pTooltip="{{ 'basic-profile.jurisdiction.meter-data.location-info' | translate }}"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="meterDataSection.isDataEditable" class="ui-g-12 margin-align add-meter-btn">
      <span *ngIf="!environmentService.copyExistingTechnicalDataConfiguration">
        <i (click)="addMeter(true)" class="pi pi-plus plus-icon" id="base-data-add-facility"></i>
        <label class="add-meter-txt form-font-size" for="base-data-add-facility">
          {{ 'basic-profile.jurisdiction.meter-data.add_meter' | translate }}
        </label>
      </span>
      <ng-container *ngIf="showFloor">
        <span>
          <button [disabled]="!count || count < 0" (click)="addMultipleMeterData()" class="pi pi-copy copy-icon"></button>
          <label class="add-meter-txt form-font-size" for="base-data-add-facility">
            {{ 'basic-profile.jurisdiction.meter-data.copy_counter' | translate }}
          </label>
          <input
            type="number"
            class="copy-counter"
            (keyup)="counter($event)"
            name="count"
            value=""
            [(ngModel)]="count"
            [ngModelOptions]="{ standalone: true }" />
          <i class="pi pi-caret-up caret up" (click)="caretUp()"></i>
          <i class="pi pi-caret-down caret down" (click)="caretDown()"></i>
        </span>
      </ng-container>
    </div>
    <div *ngIf="meterDataFG.get('chimneySweepConfirm')">
      <app-review-section
        [title]="'basic-profile.jurisdiction.meter-data.chimney-confirm' | translate"
        [tooltip]="'tooltips.facilities-data.chimney-confirm' | translate"
        [showTooltip]="infoBubblesData?.showChimneyConfirmInfo"
        [sectionId]="technicalDataConfirmChimenySweeperSectionIdentifier"
        [applicationId]="applicationId"
        [isDetailsView]="isDetailsView">
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <p-radioButton
              name="gas_confirm"
              value="conf_1"
              formControlName="chimneySweepConfirm"
              class="p-field-radio"
              labelStyleClass="radio-label"
              label="{{ 'lookup.sk_chim_sweep_confirm.options.conf_1.name' | translate }}"></p-radioButton>
          </div>
        </div>
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <p-radioButton
              name="gas_confirm"
              value="conf_2"
              formControlName="chimneySweepConfirm"
              class="p-field-radio"
              labelStyleClass="radio-label"
              label="{{ 'lookup.sk_chim_sweep_confirm.options.conf_2.name' | translate }}"></p-radioButton>
          </div>
        </div>
      </app-review-section>
    </div>
  </form>
</div>
